export default __webpack_public_path__ + "static/media/index.4600cfe9.svg";